import isBlank from "@sedan-utils/is-blank";
import { RestMethod } from "../cutil/StreamClient";
import { ErrorUtil } from "../api/ErrorUtil";
import { AskBrainData } from "../api/askBrainTyped/AskBrain";
import { UpdateEdgeResponse } from "./updateEdgeType/updateEdge";
import { UpdateNodeResponse } from "./updateNodeType/updateNode";
import { GlobalContextData } from "./globalContextTyped/GlobalContext";
import { FunctionSuggestions } from "./functionSuggestionsTyped/FunctionSuggestions";
import { ToolPiece, ToolPieces } from "./toolPiecesTyped/ToolPieces";
import { Blueprints } from "./blueprintsTyped/Blueprints";
import { BlueprintDetails } from "./blueprintDetailTyped/BlueprintDetail";
import { BlueprintResponse, MissingApis, ToolPieceData } from "./blueprint/Blueprint";
import { BlueprintResponseV2 } from "./blueprint/BlueprintV2";
import { ToolBoxInput } from "./blueprint/ToolBoxInput";
import { CotTemplateResponseData } from "../../cases/cot/typed/CotTemplateResponseData";
import { DynamicLink } from "./dynamicLinkTyped/dynamicLink";
import { PromptModelResponse, } from "./chatCompletionTyped/ChatCompletionsTyped";
export class OpenAiApi {
    constructor(restClient, streamRequest) {
        this.restClient = restClient;
        this.streamRequest = streamRequest;
    }
    completionsGeneration(objectId, input) {
        return this.streamRequest.request({
            path: "/stream/bas-demo-v4/nlp/completions_generation",
            data: {
                identifier_type: "object_id",
                identifier_value: objectId,
                stream: true,
                variables: { input: input },
            },
        });
    }
    completionsGenerationNoStream(url, domain, identifierType, identifierValue, stream, variables, uuid) {
        let data = {
            identifier_type: identifierType,
            identifier_value: identifierValue,
            variables: variables,
        };
        if (domain) {
            data["domain"] = domain;
        }
        if (stream) {
            data["stream"] = stream;
        }
        return this.restClient.post(url, data, undefined, undefined, undefined, uuid).then(res => res.validate());
    }
    splitOutput(input, uuid) {
        return this.restClient
            .post("/stream/bas-demo-v4/nlp/completions_generation", {
            identifier_type: "file",
            identifier_value: "brain_studios_xxx_shard_splitting.model",
            stream: false,
            variables: { input: input },
        }, undefined, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    askBrain(input, pubsub_topic, uuid) {
        return this.streamRequest.request({
            path: "/stream/langchain/v6/ask_brain",
            data: {
                stream: true,
                query: input,
                pubsub_topic: pubsub_topic,
                stream_version: "v1",
            },
            queryParameters: {},
            headers: {},
            method: RestMethod.POST,
            uuid,
        });
    }
    blueprints(input, uuid) {
        return this.streamRequest.request({
            path: "/stream/langchain/toolbox/v2/blueprints/execute/stream",
            data: {
                blueprint_name: input,
            },
            queryParameters: {},
            headers: {},
            method: RestMethod.POST,
            uuid,
            isJsonSteaming: true,
        });
    }
    blueprintsV2(data, uuid) {
        return this.streamRequest.request({
            path: "/stream/langchain/toolbox/v2/blueprints/execute",
            data: data,
            queryParameters: {},
            headers: {},
            method: RestMethod.POST,
            uuid,
            isJsonSteaming: true,
        });
    }
    chatCompletions(data, uuid) {
        return this.streamRequest.request({
            path: "/stream/openai/v1/chat/completions",
            data: data,
            queryParameters: {},
            headers: {},
            method: RestMethod.POST,
            uuid,
        });
    }
    instantIntent(queryParameters, uuid) {
        return this.restClient
            .get("/be/bas-demo-v4/nlp/instant_intent", queryParameters, undefined, undefined, uuid)
            .then(res => res.toModelFromType(PromptModelResponse));
    }
    getToolPiecesList(uuid) {
        return this.restClient
            .get("/be/langchain/toolbox/v2/toolpieces/list", undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(ToolPieces));
    }
    toolBoxInputs(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/inputs", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(ToolBoxInput));
    }
    getBlueprintsList(uuid) {
        return this.restClient
            .get("/be/langchain/toolbox/v2/blueprints/list", undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(Blueprints));
    }
    searchBlueprints(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/blueprints/search", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(Blueprints));
    }
    searchToolPieces(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/toolpieces/search", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(ToolPieces));
    }
    blueprintDetail(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/blueprints/details", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(BlueprintDetails));
    }
    blueprintFeedback(data) {
        return this.restClient.post("/be/langchain/toolbox/v2/blueprints/update", data).then(res => res.validate());
    }
    blueprintDislike(data) {
        return this.restClient.post("/be/langchain/toolbox/v2/feedback", data).then(res => res.validate());
    }
    toolPiecesDetail(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/toolpieces/details", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(ToolPieceData));
    }
    missingApis(uuid) {
        return this.restClient
            .get("/be/langchain/toolbox/v2/blueprints/missing_apis", undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(MissingApis));
    }
    blueprintBuilder(data, uuid) {
        return this.restClient
            .post("/be/langchain/blueprint_builder", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(BlueprintResponse));
    }
    blueprintBuilderV2(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/blueprints/build", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(BlueprintResponseV2));
    }
    deleteToolPieces(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/toolpieces/delete", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(Object));
    }
    deleteBlueprints(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/blueprints/delete", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(Object));
    }
    saveBlueprints(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/blueprints/add", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(Object));
    }
    addToolPiece(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/toolpieces/add", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(ToolPiece));
    }
    askBrainAnswer(query, pubsub_topic, uuid) {
        return this.restClient
            .post("/be/langchain/v6/ask_brain", { query, pubsub_topic }, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(AskBrainData));
    }
    getStockInfo(text, uuid) {
        return this.restClient
            .get("/be/svc-adapter/stock/symbol", { text }, undefined, undefined, uuid)
            .then(res => {
            return res.parseError(res => {
                const defaultErrorMsg = ErrorUtil.parseRestResponse(res);
                return defaultErrorMsg || "Get stock failed";
            });
        })
            .then(res => res.validate());
    }
    alphafold(text, uuid) {
        return this.restClient
            .get("/be/svc-adapter/alphafold/search", { text }, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    stableai(prompt, from, uuid) {
        // return this.restClient.post("/be/lambda/function/stableai", { prompt, from });
        return this.restClient
            .post("/be/lambda/function/stableai", {
            prompt,
            from,
            json: true,
        }, undefined, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    midjourney(prompt, topic, uuid) {
        return this.restClient
            .post("/be/svc-adapter/midjourney/v2/imagine", { prompt, topic }, undefined, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    midjourneyMessage(messageId, uuid) {
        return this.restClient
            .get("/be/svc-adapter/midjourney/v2/message", { id: messageId }, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    imageSearch(q, uuid) {
        return this.restClient
            .get("/be/shopping/serpapi/search", {
            q,
            engine: "google_images",
        }, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    updateEdge(data, uuid) {
        return this.restClient
            .post("/be/langchain/canvas_descriptions/update_edge", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(UpdateEdgeResponse));
    }
    updateNode(data, uuid) {
        return this.restClient
            .post("/be/langchain/canvas_descriptions/update_nodes", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(UpdateNodeResponse));
    }
    indexers(data, uuid) {
        return this.restClient
            .post("/be/vectordb/indexers/", data, undefined, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    upload(data, uuid) {
        return this.restClient
            .post("/api/me/upload/studios", data, undefined, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    getJdShoppingInfo(keyword, page, uuid) {
        return this.restClient
            .get("/be/svc-adapter/jd/search", { keyword, page }, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    getAmazonShoppingInfo(query, page, uuid) {
        return this.restClient
            .get("/be/svc-adapter/purchasing/shop-search", {
            query,
            page,
        }, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    getWeeeGroceriesInfo(keyword, page, uuid) {
        return this.restClient
            .get("/be/svc-adapter/sayweee/search", {
            keyword,
            page,
        }, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    getWeeeShoppingInfo(keyword, page, uuid) {
        return this.restClient
            .get("/be/svc-adapter/sayweee/search", {
            keyword,
            page,
        }, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    getYoutube(keyword, pagination, uuid) {
        if (pagination === undefined) {
            return this.restClient
                .get("/be/svc-adapter/youtube/v2/search", {
                keyword,
            }, undefined, undefined, uuid)
                .then(res => res.validate());
        }
        return this.restClient
            .post("/be/svc-adapter/youtube/v2/search", pagination, undefined, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    getAddress(keyword, uuid) {
        return this.restClient
            .get("/be/svc-adapter/google/maps/address-gps", {
            address: keyword,
        }, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    async getMapTextSearch(keyword, location, uuid) {
        const locationStr = isBlank(location) ? "" : `${location[1]},${location[0]}`;
        return await this.restClient
            .get(`/be/svc-adapter/google/maps/textsearch?query=${keyword}&location=${locationStr}`, undefined, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    async getAddressDetail(placeid) {
        return await this.restClient
            .get("/be/svc-adapter/google/maps/place_details", {
            placeid,
        })
            .then(res => res.validate());
    }
    getRestaurantList(lat, lng, dish, limit, logo, open_now, mode, sorts, query, offset, uuid) {
        // ?lat=30.5740463&lng=104.0602464&dish=0&limit=5&logo=1&open_now=true&mode=delivery&sorts=default&query=pizza&offset=0
        return this.restClient
            .get("/be/svc-adapter/food/v2/search", {
            lat,
            lng,
            dish,
            limit,
            logo,
            open_now,
            mode,
            sorts,
            query,
            offset,
        }, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    getRestaurantListByNext(next, uuid) {
        return this.restClient.get(`/be/svc-adapter/${next}`, undefined, undefined, undefined, uuid);
    }
    getRestaurantInfo(id, by, lat, lng, mode, isCheckout) {
        // ?lat=30.5740463&lng=104.0602464&mode=delivery&isCheckout=0&by=DOORDASH&id=93714
        return this.restClient
            .get("/be/svc-adapter/food/detail", {
            lat,
            lng,
            mode,
            isCheckout,
            by,
            id,
        })
            .then(res => res.validate());
    }
    buyShop(url) {
        return this.restClient
            .get("/be/svc-adapter/natural/proxy", {
            url,
        })
            .then(res => res.validate());
    }
    postWithStreaming(url, params, uuid) {
        return this.streamRequest.request({ path: url, data: params, uuid });
    }
    postWithNoStreaming(url, params) {
        return this.restClient.post(url, params).then(res => res.validate());
    }
    globalContext(edgeId, graph, uuid) {
        return this.restClient
            .post("/be/cot/global_context_v2", { node_id: edgeId, graph }, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(GlobalContextData));
    }
    getSuggestedFunctions(nodeId, projectData) {
        return this.restClient
            .post("/be/cot/predict_next_node_v1 ", { node_id: nodeId, graph: projectData })
            .then(res => res.toModelFromType(FunctionSuggestions));
    }
    getGenerationPrompt(params) {
        return this.restClient.post("/be/bas-demo-v4/nlp/prompt_generation", params).then(res => res.validate());
    }
    getCotTemplateGraph(url, params) {
        return this.restClient.post(url, params).then(res => res.toModelFromType(CotTemplateResponseData));
    }
    completionsGenerationV2(params) {
        return this.restClient.post("/be/bas-demo-v4/nlp/completions_generation", params).then(res => res.validate());
    }
    dynamicLink(params) {
        return this.restClient
            .post("/analytics/studios_share/dynamiclink/", params)
            .then(res => res.toModelFromType(DynamicLink));
    }
    dynamicLinkV2(params) {
        return this.restClient
            .post("/analytics/studios_share_v2/dynamiclink/", params)
            .then(res => res.toModelFromType(DynamicLink));
    }
}
